import { useEffect, useRef } from "react";
import "./AboutIntro.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import about1 from "../../assets/about1.jpg";
import about2 from "../../assets/about2.jpg";

gsap.registerPlugin(ScrollTrigger);

export default function AboutIntro() {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const textRef = useRef(null);
  const imagesRef = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {

      // 🔥 Title cinematic reveal
      gsap.from(titleRef.current, {
        y: 80,
        opacity: 0,
        duration: 1.2,
        ease: "power4.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 70%",
        }
      });

      // ✨ paragraph reveal
      gsap.from(textRef.current, {
        y: 50,
        opacity: 0,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 65%",
        }
      });

      // 🖼 images cinematic zoom reveal
      imagesRef.current.forEach((img, i) => {
        gsap.from(img, {
          scale: 1.2,
          opacity: 0,
          duration: 1.4,
          ease: "power4.out",
          delay: i * 0.2,
          scrollTrigger: {
            trigger: img,
            start: "top 85%",
          }
        });
      });

    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section id="about-intro" className="about-showcase" ref={sectionRef}>

      <div className="container">

        {/* HEADER */}
        <div className="row align-items-center showcase-header">

          <div className="col-lg-6">

            <span className="showcase-tag">ABOUT US</span>

            <h2 className="showcase-title" ref={titleRef}>
              Leading the way in AI, IoT, and <span style={{'color' : "#08469a"}}>Custom Software Development.</span>
            </h2>

          </div>

          <div className="col-lg-6">

            <div className="showcase-content" ref={textRef}>
              <p>
                Glintgan Technologies have a dedicated team of engineers, data scientists, and developers.
                Our core mission is to create intelligent, connected, and scalable ecosystems.
              </p>
            </div>

          </div>

        </div>

        {/* IMAGES */}
        <div className="row g-4 showcase-images">

          <div className="col-lg-6">
            <div className="showcase-image-wrapper">
              <img
                ref={(el) => (imagesRef.current[0] = el)}
                src={about1}
                alt=""
                className="showcase-image"
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="showcase-image-wrapper">
              <img
                ref={(el) => (imagesRef.current[1] = el)}
                src={about2}
                alt=""
                className="showcase-image"
              />
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}